import React from 'react';
import axios from 'axios';

import { IDrugStoreInfo } from 'src/entity/DrugStoreEntity';
import { ILogistic } from 'src/entity/logistics';
import { MallService } from 'src/services/MallService';
import OrderPrintService from 'src/services/OrderPrintService';
import OrderService from 'src/services/OrderService';
import { Modal, Button, message } from 'antd';
import { IOrderListInfo } from 'src/entity/OrderEntity';
import { IExpressConfig, IPickUpTimeSelect } from 'src/entity/SettingEntity';
import DrugStoreService from 'src/services/DrugStoreService';
import PickUpTime from './components/PickUpTime';
import * as moment from 'moment';

interface IPrintExpressProps {
  drugStoreInfo?: IDrugStoreInfo;
  order?: IOrderListInfo;
  onOk?: () => void;
  onCancel?: () => void;
  /**
   * @id 订单主键
   * @newExpress 新建的运单
   */
  onExpressChange?: (id: string, newExpress: ILogistic) => void;
}

interface IPrintExpressState {
  visible: boolean;
  expressConfig: IExpressConfig[];
  pickTime: IPickUpTimeSelect | undefined;
}

export default class PrintExpressDialog extends React.Component<IPrintExpressProps, IPrintExpressState> {
  constructor(props: IPrintExpressProps) {
    super(props);
    this.state = {
      visible: false,
      pickTime: undefined,
      expressConfig: [],
    };
  }

  componentDidMount() {
    const { onCancel } = this.props;
    if (this.checkDeliverInfo()) {
      this.setState({ visible: true });
    } else {
      if (onCancel) {
        onCancel();
      }
    }
  }

  async UNSAFE_componentWillMount() {
    // 境内配药中心获取快递配置
    this.getExpressConfig();
  }

  /**
   * 获取快递配置信息
   */
  async getExpressConfig() {
    try {
      const res = await DrugStoreService.fetchExpressConfig();
      if (Array.isArray(res) && res.length > 0) {
        this.setState({ expressConfig: res });
      }
    } catch (error) {
      console.error(error);
    }
  }

  private checkDeliverInfo() {
    const { drugStoreInfo } = this.props;
    if (!drugStoreInfo) {
      return false;
    }

    if (!drugStoreInfo.delivery_name || !drugStoreInfo.delivery_address || !drugStoreInfo.delivery_mobile || !drugStoreInfo.delivery_location) {
      message.warning('尚未开通此服务，请联系客服!');
      return false;
    }

    return true;
  }

  private async handleCreateAndPrintExpress() {
    const deliveryDate = this.checkPickTime();
    if (!deliveryDate) {
      return;
    }
    this.handleOk();

    const { order, drugStoreInfo, onExpressChange } = this.props;
    if (!order || !drugStoreInfo) {
      return;
    }

    const orderObj = order;

    if (!drugStoreInfo.delivery_location) {
      return;
    }

    const receiverRegion = await this.fetchStructureAddress(orderObj.receiver_structure_address);
    const senderRegion = await this.fetchStructureAddress(drugStoreInfo.delivery_location);

    const express = await MallService.createExpress({
      express_company: drugStoreInfo.express_company || '',
      express_bill_template: typeof drugStoreInfo.express_bill_template !== 'undefined' ? drugStoreInfo.express_bill_template : 100,
      is_auto_created: true,
      sender_name: drugStoreInfo.delivery_name || undefined,
      sender_address: drugStoreInfo.delivery_address || undefined,
      sender_mobile: drugStoreInfo.delivery_mobile || undefined,
      sender_region: senderRegion,
      receiver: orderObj.doctor_uuid,
      receiver_name: orderObj.receiver_name || undefined,
      receiver_region: receiverRegion,
      receiver_mobile: orderObj.receiver_mobile,
      receiver_address: orderObj.receiver_address,
      goods: [{ order_no: order.id, name: '药品' }],
      delivery_start_time: deliveryDate.delivery_start_time,
      delivery_end_time: deliveryDate.delivery_end_time,
    });

    if (express) {
      if (onExpressChange) {
        onExpressChange(orderObj.id, express);
      }

      this.printSheet(express);
    }
  }

  private checkPickTime():
    | {
        delivery_start_time: string;
        delivery_end_time: string;
      }
    | undefined {
    const { pickTime } = this.state;
    if (!pickTime) {
      message.warning('请选择上门取件时间');
      return undefined;
    } else {
      let start = '';
      let end = '';
      if (pickTime.isActual) {
        const date = new Date();
        const startTime = moment(date).format('HH:mm:ss');
        const endTime = moment(date).add('hours', 1).format('HH:mm:ss');
        start = new Date(`${pickTime.date} ${startTime}`).toISOString();
        end = new Date(`${pickTime.date} ${endTime}`).toISOString();
      } else {
        start = new Date(`${pickTime.date} ${pickTime.time.start}:00:00`).toISOString();
        end = new Date(`${pickTime.date} ${pickTime.time.end}:00:00`).toISOString();
      }
      return {
        delivery_start_time: start,
        delivery_end_time: end,
      };
    }
  }

  private async handlePrintExpress() {
    // this.setState({expressVisible: false});
    this.handleOk();

    const { order } = this.props;
    if (order && order.express) {
      this.printSheet(order.express);
    }
  }

  private async printSheet(express?: ILogistic) {
    if (express && express.sheet_template) {
      const res = await axios.get(express.sheet_template, { responseType: 'arraybuffer' });
      if (res && res.data) {
        if (express.express_company === 'SF') {
          //  顺丰打印
          const data = res.data as unknown as BlobPart;
          const blob = new Blob([data], {
            type: 'application/pdf',
          });
          OrderPrintService.printExpressPageSF(blob);
        } else {
          // 非顺丰打印 目前为京东
          const buff = res.data as ArrayBuffer;
          const str = new TextDecoder('utf-8').decode(buff);
          OrderPrintService.printExpressPage(str);
        }

        // 更新打印时间
        for (const goods of express.goods) {
          OrderService.updatePrintLogisticsDate(goods.order_no);
        }
      }
    }
  }

  private async fetchStructureAddress(address: number | string): Promise<string> {
    const area = Number(address);
    if (area > 0) {
      const location = await OrderService.getLocationArea(area);
      if (location) {
        return location.division_names;
      }
    }

    return '';
  }

  private handleCancel() {
    const { onCancel } = this.props;
    if (onCancel) {
      onCancel();
    }
  }

  private handleOk() {
    const { onOk } = this.props;
    if (onOk) {
      onOk();
    }
  }

  onPickUpTimeChange = (value: IPickUpTimeSelect | undefined): void => {
    this.setState({
      pickTime: value,
    });
  };

  render() {
    const { order, drugStoreInfo } = this.props;
    const { expressConfig } = this.state;
    const matchedExpress = expressConfig.find((item) => item.code === (drugStoreInfo && drugStoreInfo.express_company));
    const hasExpress = order && order.express && order.express.sheet_template;

    const formatExpressPayer = (): string => {
      if (!drugStoreInfo) {
        return '';
      }

      const payers: { [key: string]: string } = { macrocura: '脉景', seller: '配药中心' };
      const methods: { [key: string]: string } = { PAYG: '现付', MON: '月结' };
      const payer = payers[drugStoreInfo.express_payer] || '';
      const method = methods[drugStoreInfo.express_payment_type] || '';
      return [payer, method].join('-');
    };
    // drugStoreInfo?.express_company
    const { visible } = this.state;
    return visible ? (
      <Modal
        title={'打印运单'}
        visible={visible}
        onCancel={() => this.handleCancel()}
        footer={[
          hasExpress ? (
            <Button key="print" type="primary" onClick={() => this.handlePrintExpress()}>
              打印当前运单
            </Button>
          ) : null,
          <Button key="print-new" onClick={() => this.handleCreateAndPrintExpress()}>
            打印新运单
          </Button>,
          <Button key="cancel" onClick={() => this.handleCancel()}>
            取消
          </Button>,
        ]}
      >
        <PickUpTime onPick={this.onPickUpTimeChange} />
        <p>
          物流公司：<span>{(matchedExpress && matchedExpress.name) || ''}</span>
        </p>
        <p>
          运费支付方：<span>{formatExpressPayer()}</span>
        </p>
        <p style={{ color: '#888' }}>确认下达并打印物流运单？（注：每个订单每天最多只能下5个运单）</p>
      </Modal>
    ) : null;
  }
}



// WEBPACK FOOTER //
// ./src/components/views/Order/PrintExpressDialog.tsx